import styled from 'styled-components';

const StyledHeaderLink = styled.a(
  ({ theme }) => theme.components.HeaderLink?.customCss,
);

export default StyledHeaderLink;
